/** Catálogo de textos en español (fuente de verdad de las claves). */
export const es = {
  app: { name: 'HabitOS', tagline: 'Pequeños pasos, todos los días.' },
  nav: { today: 'Hoy', habits: 'Hábitos', brain: 'Cerebro', chat: 'Chat', stats: 'Progreso', settings: 'Ajustes', main: 'Navegación principal' },
  common: {
    save: 'Guardar',
    cancel: 'Cancelar',
    close: 'Cerrar',
    delete: 'Eliminar',
    edit: 'Editar',
    back: 'Volver',
    add: 'Añadir',
    create: 'Crear',
    confirm: 'Confirmar',
    undo: 'Deshacer',
    restore: 'Restaurar',
    yes: 'Sí',
    no: 'No',
    none: 'Ninguno',
    optional: 'opcional',
    loading: 'Cargando…',
    more: 'Más acciones',
    dash: '—',
    today: 'Hoy',
    yesterday: 'Ayer',
    retry: 'Reintentar',
    learnMore: 'Más información',
  },
  onboarding: {
    title: 'Te damos la bienvenida a HabitOS',
    p1: 'Registra hábitos que quieres construir, hábitos que quieres reducir y tareas puntuales.',
    p2: 'Funciona sin conexión y sin cuenta. Tus datos se guardan en este dispositivo.',
    p3: 'Una cuenta es opcional: puedes crearla más adelante para sincronizar, recibir avisos y usar WhatsApp.',
    accountMore: 'Qué aporta una cuenta',
    dayStart: 'El día termina a las',
    dayStartHelp: 'Lo que registres antes de esta hora cuenta para el día anterior. Útil si te acuestas tarde.',
    weekStart: 'La semana empieza el',
    start: 'Empezar',
  },
  today: {
    tryWith: 'O prueba a decirle',
    greeting: { morning: 'Buenos días', afternoon: 'Buenas tardes', evening: 'Buenas noches' },
    askTitle: 'Habla con tu asistente',
    askPlaceholder: 'Pídele algo a tu asistente…',
    suggestionsLabel: 'Sugerencias para el chat',
    suggest: {
      read: 'Quiero leer 20 minutos cada noche',
      routine: 'Organízame la semana para estudiar, entrenar y descansar',
      water: 'Recuérdame beber agua todos los días a las 11',
      today: '¿Qué tengo hoy?',
      week: 'Organízame la semana',
      neglected: '¿Qué hábitos estoy descuidando?',
    },
    consistency: 'Constancia de los últimos 7 días: {pct} % ({done} de {total})',
    consistencyNone: 'Aún no hay días cerrados para medir tu constancia.',
    planWithChat: 'Planificar con el chat',
    seeAgenda: 'Ver agenda',
    upNext: 'Ahora y después',
    now: 'Ahora',
    nothingTimed: 'No te queda nada con hora para hoy.',
    overdueTasks: 'Tienes {count} tarea vencida.|Tienes {count} tareas vencidas.',
    title: 'Hoy',
    summary: '{done} de {total} completados',
    allDone: 'Todo listo por hoy',
    emptyTitle: 'Empecemos tu día',
    emptyBody: 'Cuéntale al asistente qué quieres lograr y te propondrá un plan, o crea tu primer hábito. Algo pequeño también cuenta.',
    emptyCta: 'Crear un hábito',
    nothingTodayTitle: 'Nada programado para hoy',
    nothingTodayBody: 'Tus hábitos no tienen actividad prevista hoy. Disfruta del descanso.',
    hiddenCount: '{count} oculto por los filtros|{count} ocultos por los filtros',
    tasks: 'Tareas',
    ungrouped: 'Sin grupo',
    showFilters: 'Filtros',
    hideCompleted: 'Ocultar completados',
    hideSkipped: 'Ocultar omitidos',
    hideFailed: 'Ocultar incumplidos',
    installTitle: 'Instala HabitOS',
    installBody: 'Ábrelo como una app, úsalo sin conexión y recibe recordatorios.',
    installAction: 'Instalar',
    installIosBody: 'En Safari, pulsa Compartir y luego «Añadir a pantalla de inicio».',
    dismiss: 'Ahora no',
    tzTitle: 'Has cambiado de zona horaria',
    tzBody: 'Tu dispositivo está en {device}. HabitOS usa {current}. Los registros pasados no se moverán.',
    tzUseNew: 'Usar {device}',
    tzKeep: 'Mantener {current}',
    backupReminder: 'Tus datos solo están en este dispositivo. Exporta una copia o crea una cuenta para no perderlos.',
    backupAction: 'Exportar ahora',
  },
  habit: {
    kinds: { build: 'Construir', quit: 'Reducir o dejar', task: 'Tarea' },
    kindHelp: {
      build: 'Algo que quieres hacer con regularidad.',
      quit: 'Algo que quieres limitar. Fijas un máximo permitido.',
      task: 'Algo que haces una vez.',
    },
    status: {
      pending: 'Pendiente',
      completed: 'Completado',
      missed: 'Incumplido',
      failed: 'Marcado como fallado',
      skipped: 'Omitido',
      vacation: 'Vacaciones',
      not_scheduled: 'No programado',
      out_of_range: 'Fuera del periodo del hábito',
      overdue: 'Vencida',
      onTrack: 'Dentro del límite',
    },
    actions: {
      complete: 'Marcar como hecho',
      uncomplete: 'Desmarcar',
      increment: 'Sumar {amount}',
      decrement: 'Restar {amount}',
      record: 'Registrar',
      recordOccurrence: 'Registrar una vez',
      skip: 'Omitir',
      unskip: 'Quitar omisión',
      move: 'Mover a otro día',
      undoMove: 'Devolver a su día',
      fail: 'Marcar como fallado',
      unfail: 'Quitar marca de fallo',
      note: 'Añadir nota',
      details: 'Ver detalle',
      edit: 'Editar hábito',
      duplicate: 'Duplicar',
      archive: 'Archivar',
      unarchive: 'Reactivar',
      delete: 'Eliminar',
      timer: 'Temporizador',
    },
    skipHelp: 'Omitir sirve para días con una causa justificada (enfermedad, viaje). No rompe la racha ni cuenta en el porcentaje.',
    moveHelp: 'Mueve esta vez a otro día. La repetición no cambia y la racha se mantiene si cumples el día nuevo.',
    moveSoonest: 'Próximos días libres',
    movedAway: 'Movido al {date}.',
    movedHere: 'Viene del {date}.',
    moveDateLabel: 'Nuevo día',
    movedToast: 'Movido al {date}.',
    moveUndoneToast: 'Vuelve a su día original.',
    failHelp: 'Marcar como fallado registra que no se cumplió, aunque haya registros.',
    skipConfirmTitle: 'Omitir este periodo',
    reasonLabel: 'Motivo',
    progress: '{value} de {target}',
    progressUnit: '{value} de {target} {unit}',
    averageNeed: 'Hoy {value} de {need} {unit} · media {avg} de {target}',
    averageMet: 'Hoy {value} {unit} · media {avg} de {target}',
    limitUsed: '{value} de un máximo de {target}',
    times: '{value} de {target} veces',
    remaining: 'Quedan {amount}',
    duplicateSuffix: '(copia)',
    deletedToast: 'Hábito eliminado',
    archivedToast: 'Hábito archivado',
    loggedToast: 'Registrado',
    skippedToast: 'Omitido',
    unskipToast: 'Omisión retirada',
    autoUnskip: 'Has registrado actividad en un día omitido: se ha retirado la omisión.',
    streakDays: '{count} día|{count} días',
    streakWeeks: '{count} semana|{count} semanas',
    streakMonths: '{count} mes|{count} meses',
  },
  editor: {
    newTitle: 'Nuevo hábito',
    editTitle: 'Editar hábito',
    type: 'Tipo',
    name: 'Nombre',
    namePlaceholder: 'Por ejemplo: Leer 20 minutos',
    nameRequired: 'Escribe un nombre.',
    description: 'Descripción',
    goal: 'Objetivo',
    goalBinary: 'Marcar como hecho',
    goalNumeric: 'Cantidad',
    target: 'Meta',
    limit: 'Máximo permitido',
    limitHelp: 'Cumples si no superas este número. 0 significa no hacerlo nunca.',
    unit: 'Unidad',
    unitCustom: 'Otra…',
    unitOne: 'Unidad en singular',
    unitOther: 'En plural',
    unitOnePlaceholder: 'vaso',
    unitOtherPlaceholder: 'vasos',
    unitCustomHelp: 'Se usa el singular con 1 ("1 vaso") y el plural con el resto. Si no cambia, deja el plural vacío.',
    unitRequired: 'Escribe la unidad.',
    average: 'Cumplir por media',
    averageHelp: 'Un día flojo se compensa con los anteriores: cuenta como cumplido si la media de los últimos días alcanza lo que te propusiste. Un día sin ningún registro nunca cuenta como cumplido.',
    averageWindow: 'Días que entran en la media',
    increment: 'Incremento rápido',
    incrementHelp: 'Cuánto suma cada toque en la vista Hoy.',
    frequency: 'Frecuencia',
    freq: {
      daily: 'Todos los días',
      weekdays: 'Días concretos',
      weekly_quota: 'Veces por semana',
      monthdays: 'Días del mes',
      monthly_quota: 'Veces por mes',
      interval_days: 'Cada cierto número de días',
      yearly: 'Una vez al año',
    },
    everyWeeks: 'Repetir',
    everyWeeksOption: 'Todas las semanas|Cada {count} semanas',
    yearlyHelp: 'Se repite cada año el {date}, el día de la fecha de inicio.',
    quotaMode: 'Cómo se cuenta',
    quotaTimes: 'Número de días cumplidos',
    quotaAmount: 'Cantidad total del periodo',
    timesPerWeek: 'Veces por semana',
    timesPerMonth: 'Veces por mes',
    everyNDays: 'Cada cuántos días',
    monthDays: 'Días del mes',
    lastDay: 'Último día del mes',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de fin',
    noEndDate: 'Sin fecha de fin',
    dueDate: 'Fecha límite',
    dueTime: 'Hora',
    duration: 'Duración (minutos)',
    durationHelp: 'Cuánto tiempo ocupa en tu agenda. Sirve para avisarte si choca con otra cosa.',
    appearance: 'Apariencia',
    icon: 'Icono',
    color: 'Color',
    group: 'Grupo principal',
    secondaryGroups: 'Otros grupos',
    hideStreak: 'Ocultar racha de este hábito',
    excludedFromProgress: 'No contar en el progreso del día',
    excludedFromProgressHelp: 'Lo sigues registrando y conserva sus estadísticas y su racha, pero no entra en el porcentaje del día ni en el mapa de días cumplidos.',
    applyHistory: 'Aplicar también al historial',
    applyHistoryHelp: 'Por defecto, los cambios de meta o frecuencia se aplican desde hoy y el pasado se conserva.',
    applyHistoryImpact: 'Cambiará el estado de {count} periodo pasado.|Cambiará el estado de {count} periodos pasados.',
    errors: {
      invalid_target: 'La meta no es válida.',
      end_before_start: 'La fecha de fin no puede ser anterior a la de inicio.',
      empty_schedule: 'Elige al menos un día.',
      invalid_schedule: 'Revisa la frecuencia.',
      quit_schedule_not_allowed: 'Esta frecuencia no está disponible para hábitos de reducir.',
      generic: 'Revisa los campos marcados.',
    },
    planLimit: 'Has llegado al máximo de {limit} hábitos activos del plan gratuito. Archiva alguno o pasa a Premium.',
  },
  units: {
    count: 'vez|veces',
    min: 'min',
    h: 'h',
    km: 'km',
    steps: 'paso|pasos',
    ml: 'ml',
    l: 'l',
    pages: 'página|páginas',
    kcal: 'kcal',
    g: 'g',
  },
  weekdays: {
    short: ['L', 'M', 'X', 'J', 'V', 'S', 'D'],
    long: ['lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado', 'domingo'],
  },
  habits: {
    title: 'Hábitos',
    active: 'Activos',
    archived: 'Archivados',
    trash: 'Eliminados',
    trashHelp: 'Los hábitos eliminados se pueden restaurar.',
    groups: 'Grupos',
    newGroup: 'Nuevo grupo',
    groupName: 'Nombre del grupo',
    deleteGroup: 'Eliminar grupo',
    deleteGroupBody: 'Los hábitos del grupo no se eliminan.',
    moveUp: 'Subir {name}',
    moveDown: 'Bajar {name}',
    empty: 'No hay hábitos en esta lista.',
    search: 'Buscar hábitos',
    noResults: 'Ningún hábito coincide con la búsqueda.',
  },
  detail: {
    currentStreak: 'Racha actual',
    bestStreak: 'Mejor racha',
    successRate: 'Éxito total',
    last30: 'Últimos 30 días',
    gaps30: 'Interrupciones en 30 días',
    gapsLongest: 'La más larga: {length}',
    gapsHelp: 'Cuántas veces se cortó la constancia: varios periodos seguidos sin cumplir cuentan como una sola. Los omitidos y las vacaciones no cortan.',
    completions: 'Veces completado',
    relapse: 'Días sin superar el límite',
    avgProgress: 'Progreso medio',
    calendar: 'Calendario',
    prevMonth: 'Mes anterior',
    nextMonth: 'Mes siguiente',
    history: 'Historial del día',
    selectDay: 'Elige un día del calendario para ver o corregir sus registros.',
    noEntries: 'Sin registros este día.',
    addEntry: 'Añadir registro',
    amount: 'Cantidad',
    entryNote: 'Nota',
    deleteEntry: 'Eliminar registro',
    achievements: 'Logros',
    noAchievements: 'Aún no hay logros. Llegarán con la constancia.',
    legend: 'Leyenda',
    reminders: 'Recordatorios',
    rateHelp: 'Porcentaje de periodos cumplidos. Los omitidos y las vacaciones no cuentan.',
    retroNote: 'Puedes corregir cualquier día desde la fecha de inicio hasta hoy.',
  },
  achievements: {
    earned: '¡Logro nuevo en {habit}: {label}!',
    earnedMany: '¡Logro nuevo en {habit}: {label}, y {count} más!',
    streak: 'Racha de {count}',
    total: '{count} vez completado|{count} veces completado',
  },
  stats: {
    goals: {
      title: 'Tus objetivos',
      period: 'Del {from} al {to}',
      atRisk: '{count} hábito por debajo del {threshold} %: conviene revisarlo.|{count} hábitos por debajo del {threshold} %: conviene revisarlos.',
      allGood: 'Ningún hábito por debajo del umbral de constancia en estos días.',
      few: 'Pocos datos',
      risk: 'En riesgo',
      askChat: 'Pedir al chat un plan para retomarlos',
    },
    title: 'Progreso',
    overall: 'Resumen de los últimos 30 días',
    completedPeriods: 'Periodos cumplidos',
    activeHabits: 'Hábitos activos',
    bestCurrent: 'Racha activa más larga',
    perHabit: 'Por hábito',
    empty: 'Cuando registres actividad, aquí verás tu evolución.',
    premiumHint: 'Las tendencias semanales están disponibles en Premium.',
    weekly: 'Cumplimiento semanal (últimas 12 semanas)',
    heatTitle: 'Días cumplidos',
    heatHelp: 'Cada cuadro es un día. Cuanto más oscuro, mayor parte de los hábitos de ese día cumplidos.',
    weekday: {
      title: 'Patrón por día de la semana',
      help: 'Porcentaje de días cumplidos en cada día de la semana, en los últimos 90 días.',
      best: 'Tu mejor día es el {day} ({rate}).',
      worst: 'El que más se te resiste es el {day} ({rate}).',
      flat: 'Todavía no hay diferencias claras entre los días.',
      few: 'Hacen falta más días registrados para ver un patrón.',
      cell: '{day}: {rate} ({done} de {total})',
    },
  },
  settings: {
    title: 'Ajustes',
    general: 'General',
    language: 'Idioma',
    theme: 'Tema',
    themes: { system: 'Automático', light: 'Claro', dark: 'Oscuro' },
    time: 'Día y semana',
    dayStart: 'Hora de inicio del día',
    dayStartHelp: 'Los registros nuevos usan esta hora. Los registros existentes no cambian.',
    weekStart: 'Primer día de la semana',
    weekStartHelp: 'El cambio se aplica al terminar la semana en curso.',
    timezone: 'Zona horaria',
    tzFollow: 'Seguir al dispositivo',
    tzFixed: 'Fija',
    hideStreaks: 'Ocultar todas las rachas',
    vacations: 'Vacaciones',
    vacationsHelp: 'Durante unas vacaciones, los hábitos se omiten automáticamente y las rachas se conservan.',
    newVacation: 'Nuevas vacaciones',
    vacationName: 'Nombre',
    vacationScope: 'Afecta a',
    scopeAll: 'Todos los hábitos',
    scopeSelected: 'Hábitos seleccionados',
    noVacations: 'No hay vacaciones registradas.',
    data: 'Datos',
    exportJson: 'Exportar copia completa (JSON)',
    exportCsv: 'Exportar registros (CSV)',
    import: 'Importar copia',
    importHelp: 'Importa un archivo exportado por HabitOS. No se duplican datos.',
    importPreview: 'El archivo contiene {habits} hábitos y {entries} registros.',
    importImpact: 'Al importar · Nuevos: {added} · Cambian datos existentes: {updated} · Sin cambios: {unchanged}',
    importOverwriteHelp: 'Los datos que cambian se reemplazan por los del archivo cuando estos son más recientes. Si no estás seguro, guarda antes una copia de lo que tienes ahora.',
    importBackupFirst: 'Exportar una copia actual antes',
    importOtherAccount: 'Este archivo es de otra cuenta ({email}). Si lo importas, sus datos se añadirán a los de este dispositivo y, con la sesión iniciada, a tu cuenta.',
    importAnalyzing: 'Analizando el archivo…',
    importUnknown: 'El archivo tiene {count} elemento que esta versión de HabitOS no reconoce; no se importará. Actualiza la app para importarlo.|El archivo tiene {count} elementos que esta versión de HabitOS no reconoce; no se importarán. Actualiza la app para importarlos.',
    importInvalid: 'Se omitirá {count} elemento no válido.|Se omitirán {count} elementos no válidos.',
    importDone: 'Importación completada: {count} cambios aplicados.',
    importFailed: 'No se pudo importar la copia. Tus datos no han cambiado. Inténtalo de nuevo.',
    importErrors: {
      not_json: 'El archivo no es JSON válido.',
      wrong_format: 'El archivo no es una exportación de HabitOS.',
      newer_version: 'El archivo procede de una versión más reciente. Actualiza la app.',
      invalid_structure: 'La estructura del archivo no es válida.',
    },
    storage: 'Almacenamiento',
    storagePersisted: 'El navegador conservará los datos de forma persistente.',
    storageNotPersisted: 'El navegador podría borrar los datos si falta espacio. Instala la app o exporta copias.',
    account: 'Cuenta y sincronización',
    notifications: 'Notificaciones',
    plan: 'Plan',
    about: 'Acerca de',
    version: 'Versión {version}',
    privacy: 'Privacidad',
    privacyText: 'HabitOS no usa publicidad ni rastreo. Sin cuenta, tus datos no salen de este dispositivo.',
    wipe: 'Borrar todos los datos de este dispositivo',
    wipeConfirm: 'Se borrarán todos los hábitos y registros de este dispositivo. Esta acción no se puede deshacer. ¿Continuar?',
  },
  security: {
    sessionsTitle: 'Sesiones abiertas',
    sessionsHelp: 'Dispositivos y navegadores con tu cuenta abierta. Cierra las que no reconozcas.',
    deviceOn: '{browser} en {os}',
    unknownDevice: 'Dispositivo desconocido',
    thisDevice: 'Este dispositivo',
    sessionDates: 'Última actividad: {last} · Inicio: {created}',
    revoke: 'Cerrar',
    revokeNamed: 'Cerrar la sesión de {device}',
    revokeOthers: 'Cerrar las demás sesiones',
    sessionRevoked: 'Sesión cerrada.',
    othersRevoked: 'Se cerró {count} sesión.|Se cerraron {count} sesiones.',
    passkeysTitle: 'Llaves de acceso',
    passkeysHelp: 'Permiten entrar sin código, con el desbloqueo del dispositivo. Elimina las de dispositivos que ya no uses.',
    passkeysWhere: 'Cada llave se guarda en tu dispositivo o en su gestor de contraseñas (por ejemplo, el de Apple o el de Google). HabitOS solo guarda su parte pública, que no sirve para entrar por sí sola. Al eliminarla aquí deja de valer; para quitarla también del dispositivo, bórrala en su gestor.',
    noPasskeys: 'No tienes llaves de acceso.',
    passkeyName: 'Llave de acceso {n}',
    passkeyCreated: 'Creada: {created} · Sin usar todavía',
    passkeyDates: 'Creada: {created} · Último uso: {used}',
    removePasskey: 'Eliminar llave de acceso',
    removePasskeyNamed: 'Eliminar {name}',
    removePasskeyTitle: '¿Eliminar esta llave de acceso?',
    removePasskeyBody: 'Ya no podrás usarla para entrar. Podrás seguir entrando con un código por correo y crear otra llave.',
    passkeyRemoved: 'Llave de acceso eliminada.',
    loadFailed: 'No se pudo cargar la lista. Comprueba la conexión.',
    retry: 'Reintentar',
    actionFailed: 'No se pudo completar la acción. Comprueba la conexión e inténtalo de nuevo.',
  },
  assistant: {
    open: 'Asistente',
    title: 'Asistente',
    intro: 'Escribe lo que quieres hacer. Verás una propuesta antes de que se guarde nada.',
    inputLabel: '¿Qué quieres hacer?',
    inputHelp: 'Por ejemplo: «Recordarme estudiar mañana a las 18:00».',
    interpret: 'Interpretar',
    examplesTitle: 'Prueba con',
    examples: {
      habit: 'Crear un hábito para leer 20 minutos de lunes a viernes',
      reminder: 'Recordarme estudiar mañana a las 18:00',
      list: 'Añadir huevos y leche a la lista de compras',
      today: 'Mostrarme mis pendientes de hoy',
      log: 'Registrar que hice ejercicio durante 30 minutos',
    },
    unsupported: 'No he entendido esa orden. Prueba con crear un hábito o una tarea, un recordatorio, añadir a una lista, registrar una actividad, una nota, el diario o una sesión de enfoque.',
    clarifyTitle: 'Necesito una aclaración',
    rephrase: 'Escríbelo de otra forma para continuar.',
    proposalTitle: 'Propuesta',
    kinds: {
      create_habit: 'Crear hábito',
      create_task: 'Crear tarea',
      add_to_list: 'Añadir a una lista',
      show_today: 'Ver los pendientes de hoy (agenda)',
      log_activity: 'Registrar actividad',
      create_note: 'Guardar en el cerebro',
      journal: 'Escribir en el diario',
      start_focus: 'Empezar una sesión de enfoque',
      update_habit: 'Cambiar hábito',
      set_reminder: 'Recordatorio de hábito',
      reschedule_task: 'Reprogramar tarea',
      log_focus: 'Registrar sesión de enfoque',
      archive_habit: 'Archivar hábito',
      delete_habit: 'Eliminar hábito',
    },
    fields: {
      category: 'Categoría',
      name: 'Nombre',
      type: 'Tipo',
      frequency: 'Frecuencia',
      goal: 'Meta',
      max: 'Máximo {value} {unit}',
      binaryGoal: 'Marcar como hecho',
      date: 'Fecha',
      noDate: 'Sin fecha',
      time: 'Hora',
      noTime: 'Sin hora',
      reminder: 'Recordatorio',
      reminderYes: 'Sí, a esa hora',
      reminderNo: 'No',
      list: 'Lista',
      newList: '{name} (nueva)',
      items: 'Elementos',
      habit: 'Hábito',
      amount: 'Cantidad',
      markDone: 'Marcar como hecho',
      text: 'Texto',
      duration: 'Duración',
    },
    freq: { daily: 'Todos los días', quota: '{count} vez por semana|{count} veces por semana', everyWeeks: '{days}, cada {count} semanas', yearly: 'una vez al año' },
    reminderNote: 'El aviso llega como notificación si tienes cuenta y las notificaciones activadas en este dispositivo.',
    warnDelete: 'Se moverá «{name}» a la papelera. Podrás deshacerlo justo después o restaurarlo desde Hábitos.',
    warnArchive: '«{name}» dejará de aparecer en Hoy. Conserva su historial y podrás restaurarlo.',
    confirm: { default: 'Confirmar', archive_habit: 'Archivar', delete_habit: 'Eliminar' },
    editInForm: 'Editar en el formulario',
    undone: 'Deshecho.',
    q: {
      invalidTime: 'Esa hora no existe. ¿Puedes escribirla de nuevo (por ejemplo, 18:00)?',
      invalidDate: 'Esa fecha no existe. ¿Puedes escribirla de nuevo?',
      whatTask: '¿Qué tengo que recordarte?',
      pastDate: 'Esa fecha ya pasó. Indica una fecha a partir de hoy.',
      timePassed: 'Hoy a las {time} ya pasó. ¿Lo dejo para mañana a la misma hora?',
      whatTime: '¿A qué hora quieres el recordatorio?',
      whatHabit: '¿Qué hábito quieres crear?',
      futureLog: 'No se pueden registrar actividades en días futuros.',
      unitMismatch: 'No puedo convertir esa cantidad a la unidad de «{name}». Escríbela en su unidad.',
      whichHabit: '¿En qué hábito?',
      noHabit: 'No tienes un hábito llamado «{name}». ¿Quieres crearlo?',
      whatItems: '¿Qué quieres añadir a la lista?',
      noHabitToChange: 'No encuentro un hábito que coincida con «{name}».',
      focusRange: 'La sesión de enfoque debe durar entre 1 y 180 minutos.',
    },
    done: {
      habit: 'Hábito «{name}» creado.',
      task: 'Tarea «{name}» creada.',
      reminderActive: 'Tarea «{name}» creada con recordatorio: recibirás una notificación a esa hora.',
      reminderSaved: 'Tarea «{name}» creada y recordatorio guardado. La notificación solo se enviará cuando tengas cuenta y notificaciones activadas en este dispositivo.',
      list: 'Se añadió {count} elemento a {list}.|Se añadieron {count} elementos a {list}.',
      today: 'Estos son tus pendientes de hoy.',
      alreadyDone: '«{name}» ya estaba marcado hoy.',
      marked: '«{name}» marcado como hecho.',
      logged: 'Registrado: {amount} en «{name}».',
      idea: 'Idea guardada en el cerebro.',
      fact: 'Guardado en tu Cerebro · Dato.',
      quote: 'Guardado en tu Cerebro · Cita.',
      contact: 'Guardado en tu Cerebro · Contacto.',
      note: 'Nota guardada en el cerebro.',
      journal: 'Guardado en el diario.',
      focusBusy: 'Ya hay una sesión de enfoque en curso.',
      focus: 'Sesión de enfoque de {count} minuto iniciada.|Sesión de enfoque de {count} minutos iniciada.',
      habitReminderActive: 'Hábito «{name}» creado con recordatorio a las {time}: recibirás una notificación.',
      habitReminderSaved: 'Hábito «{name}» creado y recordatorio a las {time} guardado. La notificación solo se enviará cuando tengas cuenta y notificaciones activadas en este dispositivo.',
      updated: '«{name}» actualizado desde hoy.',
      reminderSetActive: 'Recordatorio de «{name}» a las {time}: recibirás una notificación.',
      reminderSetSaved: 'Recordatorio de «{name}» a las {time} guardado. La notificación solo se enviará cuando tengas cuenta y notificaciones activadas en este dispositivo.',
      rescheduled: 'Tarea «{name}» reprogramada.',
      focusLogged: 'Sesión de enfoque de {count} minuto registrada.|Sesión de enfoque de {count} minutos registrada.',
      many: 'Plan guardado: {count} cambio.|Plan guardado: {count} cambios.',
      archived: '«{name}» archivado.',
      deleted: '«{name}» eliminado.',
    },
  },
  agenda: {
    dayModes: { hours: 'Horas' },
    timeline: 'Línea de tiempo del día',
    nowAt: 'Ahora: {time}',
    view: 'Vista',
    list: 'Lista',
    agenda: 'Agenda',
    dayNav: 'Cambiar de día',
    prevDay: 'Día anterior',
    nextDay: 'Día siguiente',
    today: 'Hoy',
    backToToday: 'Volver a hoy',
    summary: '{pending} pendientes · {done} hechos',
    slots: { morning: 'Mañana', afternoon: 'Tarde', evening: 'Noche', anytime: 'Sin hora' },
    emptyTitle: 'Nada previsto',
    emptyBodyToday: 'Los hábitos, tareas y fechas importantes de hoy aparecerán aquí, ordenados por hora.',
    emptyBodyOther: 'No hay hábitos, tareas ni fechas importantes para este día.',
    moveTomorrow: 'Pasar a mañana',
    moveOther: 'Otra fecha',
    moveTitle: 'Reprogramar tarea',
    moveConfirm: 'Reprogramar',
    moved: 'Tarea reprogramada.',
    scope: 'Periodo',
    scopes: { day: 'Día', week: 'Semana' },
    conflictsSummary: 'Hay {count} choque de horario.|Hay {count} choques de horario.',
    overlaps: 'Se solapa con {names}',
    estimated: 'duración estimada de 30 minutos',
    estimatedLegend: '* Duración estimada de 30 minutos: indícala en la tarea o el hábito para afinar los choques.',
    dropHere: 'Suelta aquí la tarea',
    weekNav: 'Cambiar de semana',
    prevWeek: 'Semana anterior',
    nextWeek: 'Semana siguiente',
    thisWeek: 'Esta semana',
    weekRange: '{from} – {to}',
    backToThisWeek: 'Volver a esta semana',
    exportIcs: 'Exportar (.ics)',
    openDay: 'Ver el día: {day}',
    free: 'Libre',
  },
  focus: {
    title: 'Enfoque',
    open: 'Sesión de enfoque',
    openFor: 'Enfocarme en este hábito',
    duration: 'Duración',
    minutes: '{count} minuto|{count} minutos',
    custom: 'Otra duración (minutos)',
    customHelp: 'Entre {min} y {max} minutos.',
    durationError: 'Elige una duración entre {min} y {max} minutos.',
    linkTo: 'Asociar con un hábito o tarea',
    noLink: 'Sin asociar',
    label: 'Etiqueta',
    start: 'Empezar',
    session: 'Sesión en curso',
    remaining: 'Quedan {time}',
    running: 'En curso',
    paused: 'En pausa',
    pause: 'Pausar',
    resume: 'Reanudar',
    finish: 'Terminar',
    cancel: 'Cancelar',
    cancelTitle: '¿Cancelar la sesión?',
    cancelBody: 'No se guardará el tiempo de esta sesión.',
    cancelConfirm: 'Cancelar la sesión',
    keepGoing: 'Seguir con la sesión',
    doneTitle: 'Sesión completada',
    finishEarlyTitle: 'Terminar antes de tiempo',
    doneBody: 'Tiempo de enfoque: {count} minuto.|Tiempo de enfoque: {count} minutos.',
    logMinutes: 'Registrar {count} min en {name}',
    markDone: 'Marcar {name} como hecho hoy',
    completeTask: 'Marcar la tarea {name} como hecha',
    save: 'Guardar sesión',
    saved: 'Sesión guardada: {count} minuto.|Sesión guardada: {count} minutos.',
    limitation: 'El tiempo se calcula aunque cierres o recargues la página. La web no puede avisarte al terminar si la app está cerrada.',
    statsTitle: 'Enfoque',
    statsSummary: 'Hoy: {today} min · Esta semana: {week} min',
    statsSessions: '{count} sesión esta semana|{count} sesiones esta semana',
    statsUnlinked: 'Sin asociar',
  },
  journal: {
    stats: {
      current: 'Racha actual',
      best: 'Mejor racha',
      entries: 'Entradas',
      week: 'Días escritos esta semana',
      written: 'escrito',
      notWritten: 'sin entrada',
      upcoming: 'por llegar',
      letters: { 1: 'L', 2: 'M', 3: 'X', 4: 'J', 5: 'V', 6: 'S', 7: 'D' },
      reviewIn: 'Faltan {count} día para tu próxima revisión semanal.|Faltan {count} días para tu próxima revisión semanal.',
      reviewToday: 'Hoy cierra la semana: buen momento para tu revisión.',
    },
    dayNav: 'Cambiar de día del diario',
    write: 'Escribir',
    editor: 'Entrada del diario',
    text: '¿Qué quieres contar de hoy?',
    optional: 'Opcional: responde solo si te apetece.',
    prompts: {
      went_well: '¿Qué salió bien?',
      remember: '¿Qué quieres recordar?',
      differently: '¿Qué harías de otra forma?',
      grateful: '¿Qué agradeces hoy?',
      tomorrow: '¿Qué te gustaría hacer mañana?',
    },
    anotherPrompt: 'Otra pregunta',
    includeInReview: 'Incluir en la revisión semanal',
    includeHelp: 'Solo aparecen en la revisión las entradas que marques.',
    inReview: 'En la revisión',
    saving: 'Guardando…',
    saved: 'Guardado',
    done: 'Listo',
    deleted: 'Entrada eliminada.',
    emptyTitle: 'Sin entradas este día',
    emptyBody: 'Unas líneas bastan. Las preguntas son opcionales.',
    entryAt: 'Entrada de las {time}',
  },
  review: {
    open: 'Revisión semanal',
    title: 'Revisión semanal',
    weekNav: 'Cambiar de semana',
    prevWeek: 'Semana anterior',
    nextWeek: 'Semana siguiente',
    inProgress: 'Semana en curso: se cuenta hasta hoy.',
    habits: 'Hábitos',
    consistency: '{done} de {total} periodos cumplidos',
    noPeriods: 'Aún no hay periodos cerrados esta semana.',
    previous: 'Semana anterior: {value}',
    habitLine: '{done} de {total}',
    howCounted: 'Cuentan los periodos cumplidos, incumplidos o marcados como fallados. Los omitidos, las vacaciones y el día en curso no cuentan.',
    other: 'Tareas y enfoque',
    tasks: 'Tareas terminadas: {count}',
    focus: 'Enfoque: {minutes} min en {count} sesiones',
    reflections: 'Reflexiones que elegiste incluir',
    noReflections: 'No hay reflexiones incluidas esta semana. Puedes marcarlas en el diario.',
  },
  brain: {
    title: 'Cerebro',
    tabs: { notes: 'Notas', lists: 'Listas', journal: 'Diario' },
    backToChat: 'Ir al chat',
    kinds: { note: 'Nota', idea: 'Idea', link: 'Enlace', date: 'Fecha importante', list: 'Lista', quote: 'Cita', fact: 'Dato', contact: 'Contacto' },
    author: 'Autor',
    details: 'Datos',
    contactHelp: 'Teléfono, correo o lo que quieras recordar de esta persona.',
    quickAdd: 'Añadir al cerebro',
    kindLabel: 'Tipo',
    titleLabel: 'Título',
    quickHelp: 'Puedes pegar un enlace directamente.',
    url: 'Enlace (https://…)',
    date: 'Fecha',
    body: 'Texto',
    tags: 'Etiquetas',
    tagsHelp: 'Separadas por comas, por ejemplo: salud, ideas',
    linkedHabits: 'Vincular con hábitos o tareas',
    pinned: 'Fijar arriba',
    add: 'Añadir',
    search: 'Buscar en el cerebro',
    filters: 'Filtros',
    all: 'Todo',
    saved: 'Guardado.',
    invalid: 'Revisa los datos: el título es obligatorio y los enlaces deben empezar por http:// o https://.',
    deleted: 'Eliminado.',
    edit: 'Editar',
    editNamed: 'Editar {title}',
    pinNamed: 'Fijar {title}',
    unpinNamed: 'Dejar de fijar {title}',
    delete: 'Eliminar',
    emptyTitle: 'Tu cerebro está vacío',
    emptyBody: 'Guarda aquí ideas, enlaces, notas y fechas que no quieras olvidar.',
    noResults: 'No hay resultados para esa búsqueda.',
    newList: 'Nueva lista',
    listsEmptyTitle: 'Aún no tienes listas',
    listsEmptyBody: 'Crea una para la compra, un viaje o lo que necesites.',
    listProgress: '{done} de {total}',
    addItemTo: 'Añadir a {title}',
    removeItemNamed: 'Quitar {text}',
    deleteListNamed: 'Eliminar la lista {title}',
    itemsRemoved: 'Se quitó {count} elemento.|Se quitaron {count} elementos.',
    clearDone: 'Quitar los completados',
    linkedTitle: 'Notas vinculadas',
  },
  account: {
    title: 'Qué aporta una cuenta',
    local: 'Sin cuenta, HabitOS funciona entero en este dispositivo: hábitos, tareas, agenda, chat, Cerebro, diario y exportación. Tus datos no salen de aquí.',
    withTitle: 'Con una cuenta, además:',
    sync: 'Sincronizar entre tus dispositivos, con una copia en el servidor.',
    push: 'Recordatorios por notificación y resumen de la mañana.',
    whatsapp: 'Escribirle al asistente por WhatsApp, si el servidor lo tiene configurado.',
    ai: 'Ayuda de IA en el chat, si el servidor la ofrece.',
    access: 'Sin contraseñas: entras con un código que te llega por correo o con una llave de acceso.',
    export: 'Exportar tus datos es gratis siempre, con o sin cuenta.',
    cta: 'Crear una cuenta o entrar',
    settingsSignedOut: 'Opcional: sincroniza, recibe avisos y usa WhatsApp',
    settingsSignedIn: 'Sesión iniciada',
    needs: {
      push: 'Los recordatorios y el resumen de la mañana se envían desde el servidor, así que necesitan una cuenta.',
      whatsapp: 'WhatsApp necesita una cuenta: el asistente responde desde el servidor con tus datos sincronizados.',
      premium: 'Para pasar a Premium hace falta una cuenta: el plan se guarda en ella.',
      rest: 'Todo lo demás sigue funcionando en este dispositivo sin cuenta.',
    },
  },
  sync: {
    title: 'Cuenta y sincronización',
    intro: 'Crea una cuenta para sincronizar tus hábitos entre dispositivos y tener una copia en el servidor. HabitOS sigue funcionando sin conexión.',
    email: 'Correo electrónico',
    sendCode: 'Enviar código',
    codeSent: 'Te hemos enviado un código a {email}. Caduca en 10 minutos.',
    codeResent: 'Te hemos enviado un código nuevo a {email}. Usa el del último correo: los anteriores ya no valen.',
    codeHelp: 'Puedes pegar el código completo; los espacios y guiones se quitan solos. Tienes 5 intentos.',
    resend: 'Reenviar código',
    resendIn: 'Podrás pedir otro código en {count} segundo.|Podrás pedir otro código en {count} segundos.',
    resendCapped: 'Ya pediste {count} códigos en 15 minutos, el máximo. Podrás pedir otro a las {time}.',
    notArrived: 'Si no llega, revisa la carpeta de spam y que el correo esté bien escrito.',
    otherEmail: 'Usar otro correo',
    passkeyWhat: 'Con una llave de acceso entras con la huella, la cara o el PIN de tu dispositivo, sin esperar un código. Se crea después de entrar, en esta misma pantalla.',
    code: 'Código de 6 dígitos',
    verify: 'Verificar',
    passkey: 'Entrar con llave de acceso',
    addPasskey: 'Añadir llave de acceso a este dispositivo',
    passkeyAdded: 'Llave de acceso añadida.',
    signedInAs: 'Sesión iniciada como {email}',
    status: { idle: 'Sincronizado', syncing: 'Sincronizando…', offline: 'Sin conexión: los cambios se enviarán al reconectar', error: 'Error de sincronización', pending: '{count} cambio pendiente|{count} cambios pendientes' },
    lastSync: 'Última sincronización: {time}',
    never: 'Nunca',
    syncNow: 'Sincronizar ahora',
    logout: 'Cerrar sesión',
    logoutWipe: 'Cerrar sesión y borrar los datos de este dispositivo',
    logoutAll: 'Cerrar sesión en todos los dispositivos',
    deleteAccount: 'Eliminar cuenta',
    deleteAccountBody: 'Se eliminará tu cuenta y todos los datos del servidor. Exporta una copia antes si la necesitas. Para confirmar, te enviaremos un código.',
    deleteAccountConfirm: 'Eliminar definitivamente',
    accountDeleted: 'Cuenta eliminada.',
    mergeTitle: 'Ya tienes datos en este dispositivo',
    mergeBody: 'La cuenta puede tener datos de otros dispositivos. ¿Qué quieres hacer con los datos locales?',
    mergeKeep: 'Combinar con la cuenta',
    mergeDiscard: 'Descartar los datos locales',
    accountDataTitle: 'Datos de tu cuenta',
    accountDataHelp: 'Descarga lo guardado en el servidor: tus hábitos y registros sincronizados y los datos de la cuenta (correo, sesiones, llaves de acceso, plan y registro de seguridad). No incluye contraseñas ni claves. El archivo se puede importar en Ajustes > Datos.',
    accountDataDownload: 'Descargar los datos de mi cuenta',
    sessionExpiredTitle: 'Tu sesión se cerró',
    sessionExpiredBody: 'La sesión de este dispositivo caducó o se cerró desde otro dispositivo. Tus datos siguen aquí; vuelve a iniciar sesión para seguir sincronizando.',
    sessionExpiredAction: 'Volver a iniciar sesión',
    otherAccountTitle: 'Estos datos son de otra cuenta',
    otherAccountBody: 'Los datos de este dispositivo pertenecen a {previous}. Si los combinas, se copiarán en la cuenta {current}.',
    otherAccountUnknown: 'otra cuenta',
    otherAccountMerge: 'Copiarlos en esta cuenta',
    unsyncedTitle: 'Hay cambios sin sincronizar',
    unsyncedKeepBody: '{count} cambio aún no ha llegado a tu cuenta. Si cierras sesión ahora, se quedará solo en este dispositivo.|{count} cambios aún no han llegado a tu cuenta. Si cierras sesión ahora, se quedarán solo en este dispositivo.',
    unsyncedWipeBody: '{count} cambio aún no ha llegado a tu cuenta. Si cierras sesión y borras los datos ahora, se perderá definitivamente.|{count} cambios aún no han llegado a tu cuenta. Si cierras sesión y borras los datos ahora, se perderán definitivamente.',
    unsyncedStay: 'Seguir con la sesión iniciada',
    unsyncedLeave: 'Cerrar sesión igualmente',
    rejected: '{count} cambio rechazado por el servidor|{count} cambios rechazados por el servidor',
    rejectedHelp: 'Siguen guardados en este dispositivo, pero no se sincronizan. Resuelve la causa (por ejemplo, archiva un hábito si superas el límite del plan) y pulsa Reintentar.',
    rejectedReason: {
      plan_limit: 'supera el límite de tu plan',
      invalid: 'el servidor no aceptó los datos',
      other: 'el servidor no lo aceptó',
    },
    rejectedEntity: {
      settings: 'Ajustes',
      habits: 'Hábito',
      entries: 'Registro',
      overrides: 'Día omitido o fallado',
      groups: 'Grupo',
      vacations: 'Vacaciones',
      reminders: 'Recordatorio',
    },
    rejectedMore: 'y {count} más',
    rejectedRetry: 'Reintentar',
    rejectedRetried: 'Se reenvió {count} cambio.|Se reenviaron {count} cambios.',
    unavailable: 'El servidor de sincronización no está disponible. Puedes seguir usando HabitOS sin conexión.',
    errors: {
      invalid_email: 'Escribe un correo válido.',
      invalid_code: 'El código no es correcto o ha caducado.',
      too_many: 'Demasiados intentos. Espera unos minutos.',
      network: 'No se pudo conectar con el servidor.',
      generic: 'Algo ha fallado. Inténtalo de nuevo.',
      passkey_unsupported: 'Este navegador no admite llaves de acceso.',
      passkey_failed: 'No se pudo usar la llave de acceso.',
    },
    devMailbox: 'Modo desarrollo: el código aparece en la consola del servidor.',
  },
  notifications: {
    snoozeNote: 'Los avisos de recordatorio incluyen «Posponer 10 min» (en iPhone, las notificaciones web no muestran botones).',
    brief: 'Resumen de la mañana',
    briefHelp: 'Una notificación al día con lo que tienes hoy, calculada con tus datos reales. Tocarla abre el chat.',
    briefTime: 'Hora del resumen',
    briefNeedsPush: 'Activa las notificaciones en este dispositivo para recibirlo.',
    briefFailed: 'No se pudo guardar. Inténtalo de nuevo con conexión.',
    title: 'Recordatorios',
    intro: 'Recibe un aviso si un hábito sigue pendiente. Si ya lo completaste, no te avisaremos.',
    needInstallIos: 'En iPhone y iPad, instala HabitOS en la pantalla de inicio para recibir notificaciones.',
    unsupported: 'Este navegador no admite notificaciones push.',
    denied: 'Has bloqueado las notificaciones. Puedes reactivarlas en los ajustes del navegador para este sitio.',
    explainTitle: 'Permitir notificaciones',
    explainBody: 'El navegador te pedirá permiso. Solo enviaremos los recordatorios que configures.',
    enable: 'Activar notificaciones en este dispositivo',
    enabled: 'Notificaciones activas en este dispositivo.',
    disable: 'Desactivar en este dispositivo',
    test: 'Enviar notificación de prueba',
    testSent: 'Notificación de prueba enviada.',
    notConfigured: 'El servidor no tiene configuradas las claves de notificaciones.',
    add: 'Añadir recordatorio',
    time: 'Hora',
    days: 'Días',
    daysScheduled: 'Días programados del hábito',
    none: 'Sin recordatorios.',
    planLimit: 'El plan gratuito permite {limit} recordatorio por hábito.',
    quietHours: 'Horas de silencio',
    quietHelp: 'No se envían recordatorios en este intervalo.',
    from: 'Desde',
    to: 'Hasta',
  },
  plan: {
    title: 'Plan',
    free: 'Gratuito',
    premium: 'Premium',
    current: 'Plan actual: {plan}',
    validUntil: 'Activo hasta {date}',
    settingsSub: 'Límites de cada plan y qué pasa al llegar a ellos',
    usage: 'Usas {count} de {limit} hábitos activos.',
    bothTitle: 'Incluido en los dos planes',
    both: 'Hábitos y tareas, agenda por horas, chat con el asistente, Cerebro y listas, diario y revisión semanal, enfoque, uso sin conexión, exportación e importación.',
    bothAccount: 'Con una cuenta, en cualquier plan: sincronización entre dispositivos, recordatorios por notificación, resumen de la mañana y WhatsApp (si el servidor lo tiene configurado).',
    limitsTitle: 'Límites',
    rows: { habits: 'Hábitos activos', reminders: 'Recordatorios por hábito', trends: 'Tendencias semanales en Progreso', export: 'Exportar tus datos' },
    yes: 'Sí',
    no: 'No',
    exportFree: 'Exportar es gratis siempre: en cualquier plan, con o sin cuenta (Ajustes → Datos).',
    atLimitTitle: 'Qué pasa al llegar al límite',
    atLimit: {
      create: 'No se pueden crear más hábitos ni tareas activos. La app y el chat te avisan antes de guardar y no se guarda nada a medias.',
      archive: 'Archivar un hábito o completar una tarea libera su espacio. Lo archivado conserva su historial y puedes recuperarlo.',
      sync: 'Si otro dispositivo supera el límite, el servidor rechaza esos cambios y los verás explicados en Cuenta y sincronización. Siguen en ese dispositivo hasta que lo resuelvas.',
      expired: 'Si Premium termina, conservas todos tus hábitos y puedes editarlos; solo los nuevos respetan el límite de {limit} hábitos activos.',
    },
    premiumAdds: 'Premium amplía los límites y añade las tendencias semanales. No cambia nada más.',
    monthly: 'Mensual',
    yearly: 'Anual',
    upgrade: 'Pasar a Premium',
    cancel: 'Cancelar suscripción',
    cancelled: 'La suscripción no se renovará.',
    testMode: 'Entorno de pruebas: no se realizan cobros reales. La activación es simulada y solo sirve para probar la app.',
    unavailable: 'Los pagos no están configurados en este servidor.',
    activated: 'Premium activado (modo de prueba).',
  },
  timer: {
    title: 'Temporizador',
    start: 'Iniciar',
    pause: 'Pausar',
    resume: 'Reanudar',
    stop: 'Detener y registrar',
    discard: 'Descartar',
    running: 'En marcha',
  },
  errors: {
    title: 'Algo ha fallado',
    body: 'La aplicación ha encontrado un error inesperado. Tus datos están a salvo en este dispositivo.',
    reload: 'Recargar',
    storage: 'No se puede acceder al almacenamiento local. Si estás en modo privado, sal de él o permite el almacenamiento para este sitio.',
    future_date: 'No puedes registrar días futuros.',
    before_start: 'Ese día es anterior al inicio del hábito.',
    not_scheduled: 'Ese día no está programado.',
    same_day: 'Elige un día distinto.',
    not_movable: 'Este hábito no se puede trasladar: solo se trasladan los días concretos, no las cuotas ni las tareas.',
    source_not_scheduled: 'Ese día ya no está programado, así que no hay nada que trasladar.',
    target_out_of_range: 'Ese día queda fuera del periodo del hábito.',
    target_scheduled: 'Ese día ya está ocupado por este hábito.',
    save: 'No se pudo guardar. Inténtalo de nuevo.',
  },
  assistantSettings: {
    title: 'Asistente y Cerebro',
    summary: 'IA, memoria, privacidad, notas, listas, diario e integraciones',
    ai: {
      checking: 'Comprobando…',
      connected: 'Conectada',
      use: 'Usar la IA cuando las reglas no entiendan',
      useHelpLocal: 'Solo se consulta si las reglas no están seguras. El modelo corre en tu ordenador (Ollama).',
      useHelpRemote: 'Solo se consulta si las reglas no están seguras. El mensaje se envía al proveedor configurado en el servidor.',
      providers: { none: 'Sin IA', ollama: 'Ollama (local)', openai: 'Proveedor compatible con OpenAI' },
      detail: {
        ok: 'El modelo responde. Las frases que las reglas no entienden se le consultan.',
        disabled: 'El servidor no tiene ninguna IA configurada.',
        unreachable: 'La IA configurada no responde (¿está Ollama en marcha?). Se usan las reglas.',
        model_missing: 'Ollama responde, pero el modelo configurado no está descargado.',
        error: 'La IA configurada devolvió un error. Se usan las reglas.',
        offline: 'No hay conexión con el servidor de HabitOS: se usan las reglas de este dispositivo.',
      },
      howTo: 'Cómo activar una IA gratuita',
      step1: 'Instala Ollama (gratis y de código abierto) y descarga un modelo, por ejemplo: ollama pull qwen3:4b.',
      step2: 'En el archivo .env del servidor: AI_PROVIDER=ollama y AI_MODEL=qwen3:4b.',
      step3: 'Reinicia el servidor de HabitOS. Aquí verás el estado real de la conexión.',
      title: 'Inteligencia artificial',
      rules: 'Comprensión por reglas en este dispositivo',
      notConnected: 'Sin IA conectada',
      rulesHelp: 'El asistente entiende frases con reglas locales: funciona sin conexión y no envía nada fuera. Cuando haya un modelo de IA conectado, aparecerá aquí con su estado real.',
    },
    prefs: {
      title: 'Preferencias',
      brief: 'Resumen del día al abrir el chat',
      briefHelp: 'Una vez al día: progreso de hoy, lo próximo con hora y tareas vencidas. Se calcula en este dispositivo.',
    },
    prefsMemory: {
      title: 'Lo que recuerdo de ti',
      body: 'Preferencias que me pediste recordar. Las uso como punto de partida al planificar y siempre lo explico. Solo en este dispositivo.',
      forget: 'Olvidar',
      forgetAll: 'Olvidar todo',
      forgotten: 'Preferencia olvidada',
    },
    memory: {
      title: 'Memoria y contexto',
      body: 'El chat recuerda la conversación en curso para entender referencias como «ese hábito» o «el segundo». Se guarda solo en este dispositivo y se borra tras {hours} h sin uso, al cerrar sesión o al vincular otra cuenta.',
      current: 'Conversación actual: {count} mensajes (última actividad: {date}).',
      empty: 'No hay ninguna conversación guardada.',
      clear: 'Borrar la conversación',
      cleared: 'Conversación borrada',
    },
    privacy: {
      aiLocal: 'Las frases que las reglas no entienden se envían a la IA de tu propio ordenador (Ollama), con los nombres de tus hábitos y tareas. Nada sale a internet.',
      aiRemote: 'Las frases que las reglas no entienden se envían al proveedor de IA configurado en el servidor, con los nombres de tus hábitos y tareas. Nunca tus registros, notas ni diario.',
      title: 'Privacidad',
      local: 'Tus hábitos, tareas, notas y diario no salen de este dispositivo para que el asistente los entienda.',
      confirm: 'El asistente nunca guarda, cambia ni borra nada sin que confirmes la propuesta.',
      journal: 'El texto del diario y de las notas no se copia en la conversación: solo se muestra cuando lo pides.',
    },
    brain: {
      title: 'Cerebro',
      body: 'Tus notas, listas y diario. El chat guarda aquí lo que le pides recordar.',
    },
    whatsapp: {
      what: 'Escríbele al asistente desde WhatsApp: consultas, propuestas con botones para confirmar y deshacer. Los cambios llegan a la app al sincronizar.',
      notConfigured: 'El servidor de HabitOS no tiene WhatsApp configurado. Requiere una app en Meta (WhatsApp Cloud API) y una URL pública; Meta puede pedir un método de pago. Ver docs/whatsapp.md.',
      getCode: 'Vincular mi WhatsApp',
      sendCode: 'Envía este mensaje desde tu WhatsApp a {number}:',
      theNumber: 'el número del asistente',
      expires: 'El código caduca a las {time} y solo sirve una vez.',
      linked: 'Vinculado con el número {number}.',
      unlink: 'Desvincular',
      privacy: 'Los mensajes pasan por los servidores de WhatsApp (Meta). Nada se guarda sin que confirmes.',
    },
    integrations: {
      title: 'Integraciones',
      whatsapp: { name: 'WhatsApp', body: 'Escribirle al asistente desde WhatsApp. Requiere configurar el servidor.' },
      googleCalendar: { name: 'Google Calendar', body: 'Ver tus eventos junto a tus tareas. Todavía no disponible.' },
    },
    status: { available: 'Activa', setup: 'Requiere configuración', unavailable: 'No disponible' },
  },
  chat: {
    title: 'Chat',
    shortcuts: { label: 'Accesos directos', agenda: 'Agenda', lists: 'Listas', notes: 'Notas', journal: 'Diario' },
    intro: 'Conversa con el asistente. Puede consultar tus datos y proponer cambios; nada se guarda sin tu confirmación.',
    privacy: 'Funciona en este dispositivo, sin enviar datos fuera. La conversación se borra a las 24 h sin uso.',
    privacyAi: 'La IA solo se consulta cuando las reglas no entienden; recibe el mensaje y los nombres de tus hábitos, nunca tus registros. La conversación se borra a las 24 h sin uso.',
    ai: { on: 'IA: {provider} · {model}', off: 'Sin IA: reglas en este dispositivo' },
    newConversation: 'Nueva conversación',
    history: 'Conversación con el asistente',
    loading: 'Cargando conversación…',
    emptyTitle: '¿En qué te ayudo?',
    emptyBody: 'Puedo planificar objetivos y tu semana, responder sobre tus hábitos, tareas y agenda, y registrar cosas. Siempre te enseño la propuesta antes de guardar.',
    placeholder: 'Escribe un mensaje…',
    placeholderPending: 'Responde o pide un cambio…',
    send: 'Enviar',
    you: 'Tú',
    thinking: 'Pensando…',
    applying: 'Guardando…',
    options: 'Opciones',
    suggestions: 'Sugerencias',
    errors: {
      load: 'No se pudo cargar la conversación. Cierra y vuelve a abrir el asistente.',
      step: 'Algo falló al procesar el mensaje. No se ha guardado ningún cambio.',
    },
    examples: {
      routine: 'Organízame la semana para estudiar, entrenar y descansar',
      goal: 'Quiero estudiar programación 30 minutos al día, excepto los miércoles',
      week: 'Quiero organizar mi semana',
      neglected: '¿Qué hábitos estoy descuidando últimamente?',
      agenda: '¿Qué tengo mañana?',
      task: 'Tarea preparar la presentación',
    },
    say: {
      undoNo: 'No, déjalo',
      alternative: 'Muéstrame otra alternativa',
      anyTime: 'Cuando mejor encaje',
      remind: 'Ponle un recordatorio a {name}',
      progress: '¿Cómo voy con {name}?',
      neglected: '¿Qué hábitos estoy descuidando últimamente?',
      planWeek: 'Quiero organizar mi semana',
      startFocus: 'Pomodoro',
      agendaWeek: '¿Qué tengo esta semana?',
      availWeekdayEvenings: 'Entre semana de 18 a 20',
      availMornings: 'Todos los días de 8 a 10 de la mañana',
      availWeekend: 'El fin de semana de 10 a 13',
    },
    intent: {
      remember_pref: 'Recordar una preferencia',
      query_prefs: 'Ver lo que recuerdo de ti',
      plan_routine: 'Organizar una rutina con varias actividades',
      free_day: 'Dejar un día libre',
      move_day: 'Cambiar de día un hábito o una tarea',
      alternative: 'Ver otra alternativa',
      undo_last: 'Deshacer el último cambio',
      query_habits: 'Ver mis hábitos',
      query_stats: 'Ver estadísticas de hábitos',
      query_tasks: 'Ver tareas pendientes',
      query_agenda: 'Consultar la agenda',
      query_focus: 'Ver tiempo de enfoque',
      query_notes: 'Buscar en mis notas',
      query_journal: 'Leer el diario',
      plan_week: 'Organizar la semana',
      plan_goal: 'Convertirlo en un hábito planificado',
      edit_habit: 'Cambiar un hábito o su recordatorio',
      reschedule_task: 'Reprogramar una tarea',
      log_focus: 'Registrar una sesión de enfoque',
    },
    help: {
      plan: 'Planificar un objetivo: «Quiero leer 20 minutos al día salvo el domingo».',
      week: 'Organizar la semana según tu disponibilidad.',
      stats: 'Responder con tus datos: hábitos descuidados, progreso de un hábito, resumen.',
      agenda: 'Consultar la agenda, tareas pendientes, tiempo de enfoque, notas y, si lo pides, el diario.',
      edit: 'Cambiar meta, días u horario de recordatorio de un hábito, o reprogramar tareas.',
      log: 'Registrar actividad o sesiones de enfoque.',
      capture: 'Crear tareas, recordatorios, notas, ideas, elementos de lista y entradas de diario.',
      safety: 'Antes de guardar te enseño la propuesta. Puedes cambiarla, cancelarla o deshacerla.',
    },
    c: {
      savePref: 'Sí, recuérdalo',
      keepNew: 'Quedarme solo con {count} nuevo|Quedarme solo con {count} nuevos',
      archiveSome: 'Archivar algún hábito',
      seePlans: 'Ver los planes',
      createNew: 'Crear «{name}» como hábito nuevo',
      fixDays: 'Fijar días concretos',
      anyTime: 'Cuando mejor encaje',
      removeDay: 'Quitar el {day}',
      undoNo: 'No, déjalo',
      undoYes: 'Sí, deshacer',
      yes: 'Sí, eso',
      no: 'No, lo escribo de otra forma',
      none: 'Ninguna de estas',
      option: '{summary}',
      target: '{name}',
      daily: 'Todos los días',
      weekdays: 'De lunes a viernes',
      quota: '{count} vez por semana|{count} veces por semana',
      morningAt: 'Por la mañana ({time})',
      afternoonAt: 'Por la tarde ({time})',
      eveningAt: 'Por la noche ({time})',
      at: 'A las {time}',
      noTime: 'Sin horario fijo',
      tomorrow: 'Mañana',
      nextMonday: 'El próximo lunes',
      remind: 'Recordatorio para «{name}»',
      progress: 'Cómo voy con «{name}»',
      neglected: 'Hábitos descuidados',
      createHabit: 'Planificar un hábito',
      createTask: 'Crear una tarea',
      planWeek: 'Organizar la semana',
      agendaWeek: 'Ver la agenda de la semana',
      openAgenda: 'Abrir la agenda',
      openBrain: 'Abrir el cerebro',
      startFocus: 'Empezar un pomodoro',
      availWeekdayEvenings: 'Entre semana, 18–20',
      availMornings: 'Mañanas, 8–10',
      availWeekend: 'Fin de semana, 10–13',
      otherAvailability: 'Indicar otra disponibilidad',
    },
    q: {
      didYouMean: '¿Quieres esto: {what}?',
      whichIntent: 'No estoy seguro de lo que pides. ¿Te refieres a alguna de estas opciones?',
      activity: '¿Qué actividad quieres planificar?',
      days: '¿Qué días quieres hacer «{name}»?',
      daysAgain: 'No he reconocido los días. Prueba con «todos los días», «de lunes a viernes» o «excepto los miércoles».',
      goalTime: '¿Quieres fijar un horario? Así compruebo si choca con algo y te pongo un recordatorio. También puedes dejarlo sin hora.',
      newTime: '¿A qué hora?',
      timeAgain: 'No he reconocido la hora. Escríbela, por ejemplo «a las 19:00» o «por la mañana».',
      ambiguousTime: '¿A las {a} o a las {b}?',
      availability: '¿Cuándo tienes tiempo libre esta semana? Por ejemplo: «entre semana de 18 a 20 y el sábado por la mañana».',
      availabilityHint: 'Tienes {count} tarea sin hora para colocar.|Tienes {count} tareas sin hora para colocar.',
      availabilityAgain: 'No he podido sacar un horario de eso. Indica días y horas, por ejemplo «de lunes a jueves de 19 a 21».',
      rangeAmPm: '¿Esas horas son de la mañana o de la tarde? Escríbelo, por ejemplo «de 6 a 8 de la tarde».',
      whichHabit: '¿Qué hábito?',
      whichTask: '¿Qué tarea?',
      noHabits: 'No tienes hábitos activos.',
      noTasks: 'No tienes tareas pendientes.',
      notFoundTarget: 'No encuentro «{name}». Elige una de la lista o escribe su nombre.',
      whatChange: '¿Qué quieres cambiar de «{name}»? Puedes decir la hora del recordatorio, la duración o los días.',
      reminderTime: '¿A qué hora quieres el recordatorio de «{name}»?',
      whenTask: '¿Para cuándo pasamos «{name}»?',
      focusMinutes: '¿Cuántos minutos duró la sesión?',
      destructive: 'Es una acción que oculta o borra datos. Para continuar, pulsa «{verb}» en la propuesta o escribe «{verb}».',
    },
    r: {
      viaAi: 'Interpretado con ayuda de la IA. Revisa la propuesta antes de confirmar.',
      greeting: 'Hola. Dime qué quieres hacer o pregúntame por tus hábitos, tareas o agenda.',
      thanks: 'De nada.',
      helpIntro: 'Esto es lo que puedo hacer, siempre con tus datos de este dispositivo:',
      unknown: 'No he entendido el mensaje y prefiero no adivinar. Prueba con una de estas sugerencias o escríbelo de otra forma.',
      rephrase: 'De acuerdo. Escríbelo con otras palabras.',
      cancelled: 'Cancelado. No se ha modificado nada.',
      questionCancelled: 'De acuerdo, lo dejamos. No se ha modificado nada.',
      nothingToCancel: 'No hay nada pendiente que cancelar.',
      nothingToConfirm: 'No hay ninguna propuesta pendiente de confirmar.',
      nothingToModify: 'No hay ninguna propuesta abierta que cambiar. Dime qué quieres hacer.',
      notPending: 'Esa propuesta ya no está pendiente.',
      staleChoice: 'Esa opción ya no está disponible. Escribe lo que necesitas.',
      staleProposal: 'Algo de la propuesta ya no existe (quizá se borró en otro dispositivo). No se ha guardado nada.',
      noChange: 'No he visto qué cambiar. Dime, por ejemplo, «a las 19:00», «45 minutos» o «los martes y jueves».',
      cantModify: 'Esta propuesta no se puede ajustar así. Cancélala y escríbela de nuevo.',
      removeNotFound: 'No encuentro esa tarea en la propuesta.',
      weekModifyHelp: 'Puedes decir «mueve <tarea> al jueves a las 19», «quita <tarea>» o darme otra disponibilidad («de 19 a 21 entre semana»).',
      weekEmptyAfterChange: 'Sin esas tareas, la propuesta se queda vacía. La he cancelado; no se ha modificado nada.',
      opening: 'Abriendo…',
      reset: 'Conversación nueva. La anterior se ha borrado de este dispositivo.',
      applyFailed: 'No se pudo guardar.',
      nothingSaved: 'No se ha guardado ningún cambio.',
      nothingSavedRetry: 'No se ha guardado ningún cambio. Puedes volver a confirmar.',
      undoHint: 'Puedes deshacerlo desde la propuesta mientras la app siga abierta.',
      undoFailed: 'No se pudo deshacer. Revísalo en la pantalla correspondiente.',
      interrupted: 'La app se cerró mientras se guardaba una propuesta. No sé si llegó a guardarse: revísalo antes de repetirla.',
    },
    p: {
      introAdjust: 'Ya tienes «{name}». Propongo ajustarlo en lugar de crear otro:',
      orCreateNew: '¿Prefieres un hábito nuevo?',
      quotaHint: 'Con «los días que prefieras» no aparece en días concretos de la agenda. Si quieres, fijo los días.',
      altFixedDays: 'Días fijos: {days}.',
      altTime: 'Otra hora sin choques: {time}.',
      changedWeekly: 'Total semanal: {minutes} min.',
      changedFree: 'Libre: {days}.',
      intro: 'Esta es mi propuesta. Revísala antes de confirmar:',
      introGoal: 'Así lo he entendido. Revisa la propuesta:',
      introWeek: 'Propuesta para tu semana ({count} tarea):|Propuesta para tu semana ({count} tareas):',
      updated: 'He actualizado la propuesta (revisión {revision}):',
      planTitle: 'Plan con {count} cambio|Plan con {count} cambios',
      revision: 'revisión {revision}',
      why: 'Cómo lo he decidido',
      change: 'Cambiar',
      destructiveNote: 'Esta acción oculta o borra datos. Podrás deshacerla justo después.',
      previousDiscarded: 'La propuesta anterior se ha descartado sin guardar.',
      seeBelow: '(Propuesta actualizada más abajo.)',
      gone: '(Propuesta antigua, ya no disponible.)',
      changedTime: 'Horario: {time}',
      changedNoTime: 'Sin horario fijo',
      changedMinutes: 'Duración: {minutes} min',
      changedDays: 'Días cambiados',
      changedDate: 'Fecha cambiada',
      changedName: 'Nombre: {name}',
      changedAvailability: 'Nueva disponibilidad',
      moved: '«{name}» movida',
      removed: '«{name}» quitada del plan',
    },
    plan: {
      weekly: '{total} por semana repartidas en {sessions} sesiones de {minutes} minutos.',
      freeDays: 'Dejo libre: {days}.',
      adjustExisting: 'Ya existe «{name}», que es la misma actividad que «{activity}»: lo ajusto para no duplicarlo.',
      activity: 'Actividad: «{name}».',
      daily: 'Todos los días.',
      days: 'Días: {days}.',
      daysExcept: 'Días: {days} (sin {except}, como pediste).',
      quota: '{count} vez por semana, el día que prefieras.|{count} veces por semana, los días que prefieras.',
      minutes: 'Meta de {minutes} minutos por día: podrás registrar sesiones parciales.',
      noMinutes: 'Sin duración: se marca como hecho. Si quieres una duración, dímelo («30 minutos»).',
      time: 'Horario: de {time} a {end}, con recordatorio a las {time}.',
      timeFromSlot: 'Horario sugerido: {time} (pediste una franja, no una hora). De {time} a {end}.',
      noTime: 'Sin horario fijo: aparecerá en «Sin hora» en la agenda.',
      noConflicts: 'No he visto conflictos con tareas con hora ni recordatorios en los próximos {days} días.',
      conflicts: 'Hay {count} coincidencia con lo que ya tienes en los próximos {days} días:|Hay {count} coincidencias con lo que ya tienes en los próximos {days} días:',
      conflict: '{date} a las {time}: «{name}»',
      agendaScope: 'Solo compruebo lo que HabitOS conoce (tareas con hora y recordatorios). No tengo acceso a otros calendarios.',
      reminderNote: 'El aviso llega como notificación solo si tienes cuenta y las notificaciones activadas en este dispositivo.',
      duplicate: 'Ya tienes un hábito llamado «{name}». Si quieres cambiarlo en vez de crear otro, cancela y dime «cambia {name}».',
      editFromToday: 'El cambio se aplica desde hoy; el historial anterior se conserva tal cual.',
    },
    week: {
      period: 'Período: del {from} al {to}.',
      window: 'Disponibilidad: {days}, de {start} a {end}.',
      assumedAllDays: 'No indicaste días, así que he usado esa franja todos los días.',
      order: 'Primero las vencidas, después las que tienen fecha y al final las que no tienen.',
      block: 'He reservado {minutes} minutos por tarea porque HabitOS no guarda cuánto dura cada una.',
      avoided: 'He evitado las horas en las que ya tienes tareas o recordatorios.',
      habits: 'Tus {count} hábito siguen igual; solo propongo horas para tareas.|Tus {count} hábitos siguen igual; solo propongo horas para tareas.',
      unplaced: 'No caben en tu disponibilidad: {names}. Se quedan como están.',
      daysWithoutRange: 'No indicaste horario para: {days}. No los he usado.',
      noTasks: 'No tienes tareas pendientes sin hora para los próximos 7 días, así que no hay nada que organizar.',
      noTasksDetail: 'Tengo en cuenta tareas vencidas, sin fecha o con fecha esta semana pero sin hora. Los hábitos ya se repiten solos.',
      nothingFits: 'Con esa disponibilidad no he podido colocar ninguna tarea. No he propuesto cambios.',
    },
    limit: {
      routine: 'Esta rutina agrega {adds} hábitos; con el plan gratuito te quedaría {count} espacio.|Esta rutina agrega {adds} hábitos; con el plan gratuito te quedarían {count} espacios.',
      routineOne: 'Esta rutina agrega 1 hábito; con el plan gratuito te quedaría {count} espacio.|Esta rutina agrega 1 hábito; con el plan gratuito te quedarían {count} espacios.',
      proposal: 'Esta propuesta agrega {adds} hábitos; con el plan gratuito te quedaría {count} espacio.|Esta propuesta agrega {adds} hábitos; con el plan gratuito te quedarían {count} espacios.',
      proposalOne: 'Esta propuesta agrega 1 hábito; con el plan gratuito te quedaría {count} espacio.|Esta propuesta agrega 1 hábito; con el plan gratuito te quedarían {count} espacios.',
      last: 'Esto agrega {count} hábito y ocupa el último espacio del plan gratuito ({limit} hábitos activos).|Esto agrega {count} hábitos y ocupa los últimos espacios del plan gratuito ({limit} hábitos activos).',
      over: 'Esto agrega {adds} hábitos, pero a tu plan solo le queda {count} espacio ({active} de {limit} hábitos activos en uso).|Esto agrega {adds} hábitos, pero a tu plan solo le quedan {count} espacios ({active} de {limit} hábitos activos en uso).',
      full: 'Ya tienes {count} de los {limit} hábitos activos que permite tu plan: no cabe ninguno nuevo.',
      adjust: 'Así no cabe en tu plan. ¿Quieres ajustarla antes de guardar?',
      blocked: 'No la guardo así: superaría el límite de tu plan. Puedes ajustarla primero.',
      nothingSaved: 'No se ha guardado nada. Archivar un hábito libera su espacio y conserva su historial.',
      alreadyFits: 'La propuesta ya cabe en tu plan.',
      nothingLeft: 'Sin hábitos nuevos no queda nada que proponer. No se ha guardado ningún cambio.',
      removed: 'Quité: {names}.',
    },
    routine: {
      intro: 'Esta es tu rutina con {count} actividad. Revísala:|Esta es tu rutina con {count} actividades. Revísala:',
      askAvailability: 'Para organizar {names}, ¿en qué horarios tienes disponibilidad?',
      askHint: 'Por ejemplo: «entre semana de 18 a 21 y el sábado por la mañana». Si te da igual, elijo yo horas sin choques.',
      line: '{name}: {days}, {minutes} min a las {time}.',
      lineDefault: '{name}: {days}, {minutes} min a las {time} (valores iniciales; dime si prefieres otros).',
      adjusts: 'Para «{activity}» ajusto tu hábito «{name}» en lugar de crear otro.',
      noOverlap: 'Las horas no chocan entre sí ni con tus tareas y recordatorios de los próximos {days} días.',
      howToChange: 'Puedes decir «estudiar a las 19», «entrenar 45 minutos», «déjame libre el sábado» o «muéstrame otra alternativa».',
      conflict: 'No encontré una hora libre para {name}: quedaría a las {time} y choca con algo.',
      noDays: 'No queda ningún día para {name} con los días libres pedidos.',
      tasksLeft: 'Tienes {count} tarea sin hora; para colocarla, di «organízame la semana».|Tienes {count} tareas sin hora; para colocarlas, di «organízame la semana».',
      nothing: 'No he podido armar la rutina con esos datos. No he propuesto cambios.',
      whichActivity: '¿A cuál te refieres? {names}.',
      changed: 'Actualizado: {name}.',
      modifyHelp: 'Dime qué cambiar y de qué actividad, por ejemplo «estudiar a las 19» o «entrenar los martes y jueves».',
    },
    free: {
      intro: 'Para dejar libre {days}, propongo:',
      period: 'Afecta a las tareas de los próximos 7 días y, desde hoy, a los hábitos con días fijos.',
      onlyThatDay: '«{name}» solo toca ese día: no lo cambio.',
      flexible: 'Los hábitos de «X veces por semana» no tienen días fijos y no cambian: {names}.',
      alreadyFree: 'No tienes nada previsto para {days} en los próximos 7 días ni hábitos con ese día fijo.',
    },
    move: {
      explain: '«{name}» pasa del {from} al {to}. Días desde hoy: {days}.',
      flexible: '«{name}» es de «X veces por semana»: no tiene días fijos que mover. Puedes hacerlo el día que quieras.',
      unsupported: '«{name}» tiene un horario mensual o por intervalos; cámbialo desde el formulario del hábito.',
      notThatDay: '«{name}» no se hace el {day}. Ahora toca: {days}.',
      alreadyBoth: '«{name}» ya se hace el {from} y el {to}. ¿Quieres quitar el {from}?',
    },
    alt: {
      nothing: 'No hay ninguna propuesta en curso de la que buscar otra versión.',
      none: 'No encuentro otra alternativa mejor sin choques. La propuesta sigue igual.',
      notForThis: 'Para esta propuesta no hay otra versión; dime qué cambiar.',
      routine: 'Otro reparto de días y horas.',
      weekLate: 'Las tareas, lo más tarde posible dentro de la semana.',
      weekEarly: 'Las tareas, lo antes posible.',
    },
    undo: {
      nothing: 'No hay ningún cambio guardado desde el chat que deshacer.',
      confirm: '¿Deshago el último cambio guardado: {what}?',
      partial: 'Deshecho, salvo {count} elemento que cambiaste después: ese lo he dejado como está.|Deshecho, salvo {count} elementos que cambiaste después: esos los he dejado como están.',
    },
    brief: {
      pushTitle: 'Tu día en HabitOS',
      pushEmpty: 'Hoy no tienes nada previsto. Toca para planificar con el chat.',
      pushProgress: 'Hoy tienes {count} cosa.|Hoy tienes {count} cosas.',
      pushNext: 'Lo próximo: {time} · {name}.',
      morning: 'Buenos días. Así viene tu día:',
      afternoon: 'Buenas tardes. Así va tu día:',
      evening: 'Buenas noches. Así ha ido tu día:',
      empty: 'Hoy no tienes nada previsto. ¿Creamos un hábito o planificamos la semana?',
      progress: 'Llevas {done} de {total} hecho.|Llevas {done} de {total} hechos.',
      next: 'Lo próximo',
      nextItem: '{time} · {name}',
      overdue: 'Tienes {count} tarea vencida.|Tienes {count} tareas vencidas.',
      conflicts: 'Hoy hay {count} choque de horario.|Hoy hay {count} choques de horario.',
      source: 'Calculado con tus hábitos, tareas y recordatorios de hoy en este dispositivo.',
    },
    cards: { agenda: 'Agenda', habits: 'Hábitos', tasks: 'Tareas', gone: 'Ya no existe: se borró o se archivó.' },
    wa: {
      linked: 'Listo: este número quedó vinculado a tu cuenta de HabitOS. Escríbeme lo que necesites, por ejemplo «¿qué tengo hoy?» o «quiero leer 20 minutos cada noche».',
      notLinked: 'Hola. Para usar el asistente de HabitOS por WhatsApp, abre la app → Ajustes → Asistente y Cerebro → WhatsApp, genera un código y envíame «vincular» seguido del código.',
      badCode: 'Ese código no es válido o ya caducó. Genera uno nuevo en la app (Ajustes → Asistente y Cerebro → WhatsApp).',
      otherAccount: 'Este número ya está vinculado a otra cuenta. Desvincúlalo desde esa cuenta antes de vincularlo aquí.',
      tooMany: 'Demasiados intentos con códigos incorrectos. Espera unos minutos y genera un código nuevo.',
      unsupported: 'Por ahora solo entiendo mensajes de texto y los botones de mis respuestas.',
      noData: 'Todavía no tengo tus datos en el servidor. Abre HabitOS con tu cuenta iniciada para sincronizar y vuelve a escribirme.',
      appOnly: 'Eso solo se puede hacer desde la app (por ejemplo, iniciar un temporizador).',
      openApp: 'Eso se ve mejor en la app: {url}',
      confirm: 'Confirmar',
      replyNumber: 'Responde con el número de la opción.',
    },
    prefs: {
      confirm: '¿Recuerdo esto para tus próximos planes? {what}',
      saved: 'Lo recordaré: {what}',
      failed: 'No pude guardar la preferencia. No ha cambiado nada.',
      none: 'Todavía no me has pedido que recuerde nada sobre tus preferencias.',
      howTo: 'Por ejemplo: «prefiero entrenar por la mañana», «no me pongas nada antes de las 8» o «los domingos quiero descansar».',
      list: 'Esto es lo que recuerdo de ti:',
      item: '{text}',
      where: 'Se guarda solo en este dispositivo. Puedes verlo y borrarlo en Ajustes → Asistente y Cerebro.',
      usedSlot: 'Como prefieres hacerlo {slot}, propongo esa franja.',
      usedSlotFor: '{name}: {slot}, como prefieres.',
      noTimeInLimits: 'No encontré una hora para {name} dentro de tus límites de horario: la he puesto igualmente; cámbiala si quieres.',
      appOnly: 'Las preferencias se guardan en la app, en tu dispositivo. Dímelo desde el chat de HabitOS.',
      slots: { morning: 'por la mañana', afternoon: 'por la tarde', evening: 'por la noche' },
      describe: {
        earliest: 'nada antes de las {time}',
        latest: 'nada después de las {time}',
        slot: '{activity}, {slot}',
        freeDays: 'libres: {days}',
      },
    },
    voice: {
      start: 'Dictar por voz',
      stop: 'Dejar de dictar',
      listening: 'Escuchando… Revisa el texto antes de enviarlo.',
      privacy: 'El dictado usa el reconocimiento de voz del navegador (en Chrome, el audio lo procesa Google).',
      error: 'No pude usar el micrófono. Revisa el permiso del navegador.',
    },
    fields: {
      reminderAt: 'A las {time}',
      noSchedule: 'Sin horario fijo',
      from: 'Desde',
      fromToday: 'Hoy (el historial no cambia)',
      days: 'Días',
      scheduledDays: 'Los días programados',
      task: 'Tarea',
    },
    a: {
      noHabits: 'No tienes hábitos activos todavía, así que no hay estadísticas que calcular.',
      notEnoughData: 'Todavía no hay registros suficientes para sacar conclusiones.',
      neglectedIntro: 'Con tus registros, {count} hábito está por debajo del {threshold} % de cumplimiento:|Con tus registros, {count} hábitos están por debajo del {threshold} % de cumplimiento:',
      neglectedNone: 'Ningún hábito está por debajo del {threshold} % de cumplimiento. Buen trabajo.',
      lowest: 'Los que tienen el cumplimiento más bajo:',
      habitRate: '«{name}»: {done} de {total} cumplidos ({pct} %), {last}',
      lastOn: 'último registro el {date}',
      neverLogged: 'sin registros',
      fewData: 'Con pocos datos todavía (menos de {min} periodos): {names}.',
      fewDataOne: 'Aún hay pocos datos (menos de {min} periodos) para sacar conclusiones.',
      periodStats: 'Período: del {from} al {to} ({days} días). Hoy no cuenta porque sigue abierto.',
      sourceStats: 'Datos: tus registros de hábitos en este dispositivo. Los días omitidos y las vacaciones no cuentan como fallos.',
      sourceLocal: 'Datos de este dispositivo.',
      summary: 'En los últimos 7 días cumpliste {done} de {total} periodos ({pct} %).',
      progressTitle: 'Así vas con «{name}»:',
      streak: 'Racha actual: {current} {unit} (mejor: {best})',
      rate30: 'Últimos 30 días: {done} de {total} cumplidos ({pct} %)',
      rate30None: 'Últimos 30 días: sin periodos evaluables',
      completions: 'Total de veces cumplido: {count}',
      periodProgress: 'Calculado con todos tus registros desde el {from}.',
      habitsIntro: 'Tienes {count} hábito activo:|Tienes {count} hábitos activos:',
      habitLine: '«{name}» · {freq} · hoy: {today}',
      noTasks: 'No tienes tareas pendientes.',
      tasksIntro: 'Tienes {count} tarea pendiente:|Tienes {count} tareas pendientes:',
      taskItem: '«{name}» · {when}',
      undated: 'sin fecha',
      overdue: 'vencida ({date})',
      today: 'hoy',
      more: 'Y {count} más.',
      tasksHint: 'Vencidas: {overdue}. Sin fecha: {undated}. Puedo ayudarte a repartirlas en la semana.',
      agendaDay: '{date} · {pending} pendientes, {done} hechos',
      agendaItem: '{time} · {name} ({kind}){state}',
      doneMark: ' · hecho',
      overdueMark: ' · vencida',
      agendaEmpty: 'No tienes nada previsto: {period}.',
      agendaWeek: 'Esto tienes previsto ({period}): {count} elementos.',
      range: 'del {from} al {to}',
      agendaSource: 'Incluye hábitos programados, tareas y fechas importantes de HabitOS. No incluye calendarios externos.',
      focus: 'Hoy llevas {today} min de enfoque. Esta semana, {week} min en {count} sesión.|Hoy llevas {today} min de enfoque. Esta semana, {week} min en {count} sesiones.',
      focusNone: 'No hay sesiones de enfoque registradas esta semana.',
      focusItem: '{name}: {minutes} min',
      periodWeek: 'Semana del {from} al {to}.',
      notesFound: 'Encontré {count} nota con «{query}»:|Encontré {count} notas con «{query}»:',
      notesRecent: 'Tus {count} notas más recientes:',
      notesNone: 'No encontré notas con «{query}».',
      notesEmpty: 'Todavía no tienes notas.',
      notesSource: 'Busco en títulos, textos, etiquetas y elementos de listas.',
      notesGone: '(Esas notas ya no existen.)',
      journalOn: 'Tu diario del {date}:',
      journalNone: 'No hay entradas en el diario.',
      journalNoneOn: 'No hay entrada en el diario para el {date}.',
      journalPrivacy: 'Solo leo el diario cuando me lo pides, y el texto no se copia en la conversación.',
      journalGone: '(Esa entrada ya no existe.)',
    },
    kind: { habit: 'hábito', task: 'tarea', date: 'fecha' },
    unit: { day: 'día|días', week: 'semana|semanas', month: 'mes|meses' },
    weekday: { 1: 'lunes', 2: 'martes', 3: 'miércoles', 4: 'jueves', 5: 'viernes', 6: 'sábado', 7: 'domingo' },
    freq: { other: 'frecuencia personalizada' },
    status: {
      not_scheduled: 'no toca',
      pending: 'pendiente',
      completed: 'hecho',
      missed: 'no hecho',
      failed: 'superado el límite',
      skipped: 'omitido',
      vacation: 'vacaciones',
      proposal: {
        pending: 'Pendiente de confirmar',
        applying: 'Guardando',
        applied: 'Guardado',
        cancelled: 'Descartada',
        failed: 'No guardada',
        interrupted: 'Interrumpida',
        undone: 'Deshecha',
      },
    },
  },
  update: { available: 'Hay una nueva versión disponible.', reload: 'Actualizar', offlineReady: 'HabitOS está listo para usarse sin conexión.' },
};

type Widen<T> = T extends string ? string : T extends readonly string[] ? string[] : { [K in keyof T]: Widen<T[K]> };
export type Messages = Widen<typeof es>;
